import * as actions from "../global/actionTypes";

export const updateKeyword = (keyword) => ({
  type: actions.UPDATE_KEYWORD,
  keyword,
});

export const updateFilterState = (filter) => ({
  type: actions.UPDATE_FILTER_STATE,
  filter,
});
